import { gql } from "apollo-boost"

export const getCommentsMeansOfVerification = gql`
  query MeansOfVerificationComments($meansOfVerification: ID!) {
    MeansOfVerificationComments(meansOfVerification: $meansOfVerification) {
      id
      createdAt
      userType
      comment
    }
  }
`